import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { foodCategories } from '../../data/shreeData';
import { Clock, Utensils } from 'lucide-react';

const DiningSection = () => {
  return (
    <section id="dining" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-amber-100 text-amber-700 hover:bg-amber-200">Culinary Excellence</Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Dining Experiences
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Savor exquisite flavors from our multi-cuisine restaurants and cafés
          </p>
        </div>

        {/* Dining Options Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
       
{foodCategories.map((item) => (
  <Card key={item.id} className="overflow-hidden hover:shadow-xl transition-all duration-300 border-0">
    <div className="h-48 overflow-hidden">
      <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
    </div>
    <CardContent className="p-4">
      <p className="text-xs uppercase tracking-wider text-gray-500 mb-1">{item.type}</p>
      <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
      <p className="text-sm text-gray-600">{item.description}</p>
    </CardContent>
  </Card>
))}
        </div>

        {/* Features Section */}
        <div className="mt-16 bg-gradient-to-r from-teal-50 to-amber-50 rounded-2xl p-8 md:p-12">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-teal-700 mb-2">50+</div>
              <div className="text-gray-700">Menu Items</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-teal-700 mb-2">3</div>
              <div className="text-gray-700">Dining Venues</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-teal-700 mb-2">5★</div>
              <div className="text-gray-700">Food Quality Rating</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiningSection;
